<template>
  <div>
    <el-dialog
        :title="$t('posts.dialog.deleteTitle')"
        :visible.sync="modalDelete"
        @close="$emit('close-modal-delete')"
        width="30%"
    >
      <span v-if="isSoldProductsOption">{{ $t("posts.dialog.deleteTextSoldProductOption") }}</span>
      <span v-else>{{ $t("posts.dialog.deleteText") }}</span>
<!--      <span>{{ $t("posts.dialog.deleteText") }}</span>-->

      <span slot="footer" class="dialog-footer" v-if="isSoldProductsOption">
                <el-button @click="SET_MODAL_DELETE(false)">Annuler</el-button>
                <el-button type="danger"
                           @click="$emit('delete-post')"> {{ $t("posts.list.declarePostAsDeleteByNo") }}</el-button>
                <el-button type="success"
                           @click="$emit('sold-post')"> {{ $t("posts.list.declarePostAsSoldByYes") }}</el-button>
            </span>

      <span slot="footer" class="dialog-footer" v-else>
                <el-button @click="SET_MODAL_DELETE(false)">Annuler</el-button>
                <el-button type="danger" @click="$emit('delete-post')"> {{ $t("posts.list.delete") }}</el-button>
      </span>

    </el-dialog>
  </div>

</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import ElButton from '../../../../components/Button'

export default {
  name: 'DialogDeletePost',
  components: {
    ElButton
  },
  data () {
    return {
      referenceDuplication: null
    }
  },
  computed: {
    ...mapGetters([
      'hasMultiAccounts',
      'isMainAccount',
      'isSubAdmin',
      'isSubUser',
      'getOfferTypes',
      'getPickerOptionsShortcuts',
      'isSoldProductsOption'
    ]),
    ...mapGetters('dialogsPostsListImmo', ['modalDelete', 'postToDelete']),
    userFilter () {
      return this.filter.user
    }
  },
  methods: {
    ...mapMutations('dialogsPostsListImmo', ['SET_MODAL_DELETE'])
    // ...mapMutations('postsListImmo', ['DELETE_POSTS']))
  }
}

</script>
